import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Button, ButtonColor } from "../ui/Button";
import { Modal } from "./Modal";

export type ConfirmationModalProps = {
	onConfirm?: () => void;
	onCancel?: () => void;
	message?: ReactNode;
	subMessage?: ReactNode;
	confirmButtonText?: string;
	confirmButtonTestId?: string;
	confirmTrackingId?: string;
	confirmationButtonColor?: ButtonColor;
	cancelButton?: false;
	cancelButtonText?: string;
	cancelButtonColor?: ButtonColor;
	cancelTrackingId?: string;
	className?: string;
	closeOnEscape?: boolean;
};

export const ConfirmationModal = ({
	onConfirm,
	onCancel,
	message,
	subMessage,
	confirmButtonText,
	confirmButtonTestId,
	confirmTrackingId,
	confirmationButtonColor = "primary",
	cancelButton,
	cancelButtonText,
	cancelButtonColor = "secondary",
	cancelTrackingId,
	className,
	closeOnEscape,
}: ConfirmationModalProps) => (
	<Modal onClickOutside={onCancel} closeOnEscape={closeOnEscape}>
		<div
			className={cn(
				"py-[35px] px-[35px] bg-white flex flex-col items-center rounded-md shadow-lg space-y-[35px]",
				className,
			)}
		>
			<div className="flex flex-col items-center space-y-[15px]">
				{message !== undefined && (
					<div className="text-[18px] text-primary font-normal w-full flex text-center">
						{message}
					</div>
				)}
				{subMessage !== undefined && (
					<div className="text-[16px] text-secondary text-center">{subMessage}</div>
				)}
			</div>
			<div className="w-fit flex space-x-[8px] items-center">
				{cancelButton !== false && (
					<Button
						color={cancelButtonColor}
						className="w-[125px]"
						thinFont
						onClick={onCancel}
						trackingId={cancelTrackingId}
					>
						{cancelButtonText ?? "Cancel"}
					</Button>
				)}
				<Button
					testId={confirmButtonTestId}
					trackingId={confirmTrackingId}
					color={confirmationButtonColor}
					className="w-[125px]"
					filled
					onClick={() => {
						onConfirm && onConfirm();
					}}
				>
					{confirmButtonText ?? "Confirm"}
				</Button>
			</div>
		</div>
	</Modal>
);
